import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../common/Header';
import Footer from '../common/Footer';
import Cursor from '../Cursor';

function MainLayout({ children }) {
  const { pathname } = useLocation();

  // A new page starts at the top (the router keeps the old scroll position otherwise).
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="sp-shell">
      <a className="sp-skip" href="#main">Skip to content</a>
      <Header />
      <main id="main" className="sp-main">
        {/* Keyed by route so each page rises in, as elebyte.io's pages do. */}
        <div key={pathname} className="sp-enter">
          {children}
        </div>
      </main>
      <Footer />
      <Cursor />
    </div>
  );
}

export default MainLayout;
